import script from "./ServiceModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceModal.vue?vue&type=script&setup=true&lang=js"

import "./ServiceModal.vue?vue&type=style&index=0&id=6034571b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6034571b"]])

export default __exports__